export default __webpack_public_path__ + "static/media/Smart-Biology-LIFE-U1-Cover-Image.32615111.jpg";